import { FC } from 'react';
import css from './box.module.scss';
import { BoxProps } from './interface';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import CloseIcon from '@/components/UI/svg/smartDevicesTeaser/CloseIcon';

const GlacierBox: FC<BoxProps> = (props) => {
    const { useLang } = useGlobal();
    const { t } = useLang('glacierwave.teaser');

    return (
        <div className={css.glacierBox}>
            <CloseIcon className="close-icon" onClick={props.handleBoxClose} />
            <div className="product-modal-content-box">
                <div className="product-title">{t('product_glacier')}</div>
                <div className="intro-container">
                    <div className="left-top-box intro-box">
                        <NextImage
                            webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-1.webp')}
                            src={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-1.jpg')}
                        />
                        <div className="intro-box-title">
                            <div className="icon-box">
                                <NextImage
                                    webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-1-icon.webp')}
                                    src={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-1-icon.png')}
                                />
                            </div>
                            {t('glacier_fastest')}
                        </div>
                    </div>
                    <div className="center-box intro-box">
                        <NextImage
                            webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-2.webp')}
                            src={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-2.jpg')}
                        />
                        <div className="center-box-title">
                            {t.rich('glacier_ice_maker', { text: (text: string) => <div className="intro-blue-text">{text}</div> })}
                        </div>
                    </div>
                    <div className="right-top-box intro-box">
                        <NextImage
                            webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-3.webp')}
                            src={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-3.jpg')}
                        />
                        <div className="intro-box-title">
                            {t.rich('glacier_extended', { text: (text: string) => <span className="intro-blue-text">{text}</span> })}
                        </div>
                    </div>
                    <div className="left-bottom-box intro-box">
                        <NextImage
                            webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-4.webp')}
                            src={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-4.jpg')}
                        />
                        <div className="intro-box-title">
                            {t.rich('glacier_design', { blue: (text: string) => <div className="intro-blue-text">{text}</div> })}
                        </div>
                    </div>
                    <div className="r-b-l-box intro-box">
                        <NextImage
                            webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-5.webp')}
                            src={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-5.jpg')}
                        />
                        <div className="intro-box-title smart-app-title">{t('glacier_smart_app')}</div>
                    </div>
                    <div className="r-b-r-box intro-box">
                        <NextImage
                            webpSrc={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-6.webp')}
                            src={require('@publicLocal/glacier-and-wave-2/pc/mask/glacier-6.jpg')}
                        />
                        <div className="intro-box-title">
                            {t.rich('glacier_large', { size: (text: string) => <div className="intro-blue-text">{text}</div> })}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GlacierBox;
